import { render, staticRenderFns } from "./InsightDeleteModal.vue?vue&type=template&id=4745edb6&scoped=true&"
import script from "./InsightDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./InsightDeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./InsightDeleteModal.vue?vue&type=style&index=0&id=4745edb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745edb6",
  null
  
)

export default component.exports